<script>
import {mapActions, mapGetters} from "vuex";
import FilterPanel from "@/features/filters/FilterPanel.vue";
import featureMixin from "@/mixins/featureMixin";

export default {
	name: "RaddarFilterToggleButton",
	mixins: [featureMixin],
	data() {
		return {
			isOpenOld: true
		}
	},
	computed: {
		...mapGetters('drawer', ['hasContent']),
		...mapGetters('screen', ['displayMode']),
		caption() {
			return this.lang?.raddar?.toggleFilterButton?.caption;
		},
		isOpen() {
			return this.hasContent('header');
		}
	},
	created() {
		if (this.displayMode === 'desktop') this.open();
	},
	mounted() {
		//this.isOpen = this.hasContent('header');
	},
	methods: {
		...mapActions('drawer', ['addToDrawer', 'removeFromDrawer']),
		open() {
			this.addToDrawer({id: 'filters', component: FilterPanel, drawer: 'header', attrs: {class: 'raddar-filters', 'feature-config-path': 'raddar.filterPanel'}})
		},
		close() {
			this.removeFromDrawer({id: 'filters', drawer: 'header'});
		},
		toggle() {
			if (this.hasContent('header')) {
				this.close();
			} else {
				this.open();
			}
			//this.isOpen = this.hasContent('header');
		}
	}
}
</script>

<template>
	<button :class="isOpen? 'open':null" class="btn" @click="toggle">
		<svg height="24px" version="1.1" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<title>8A815149-3BD8-4D13-901A-73E8B2711BD6</title>
			<g id="R2---Desktop-wireframes" fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
				<g id="FlyerView_CTC" transform="translate(-1254, -156)">
					<g id="logo-raddar" transform="translate(1254, 156)">
						<path id="Fill-14"
						      d="M13.9685553,13.842414 C13.8580114,13.842414 13.7456095,13.8234431 13.635623,13.7834352 C13.125263,13.5974828 12.8605149,13.0285434 13.0444451,12.5125724 C13.2519705,11.9302971 12.9522942,11.2858498 12.3761652,11.0760429 C11.8013368,10.8666116 11.1631545,11.1692069 10.9554434,11.7514822 C10.7715131,12.2674533 10.2091325,12.5352999 9.6984009,12.3491596 C9.1880409,12.1632072 8.9234786,11.5940801 9.10740885,11.078109 C9.68205154,9.46595777 11.4474104,8.62654219 13.0420299,9.20750267 C14.6372068,9.78883881 15.4671224,11.5734187 14.8926655,13.1857578 C14.7484939,13.590533 14.3709724,13.842414 13.9685553,13.842414"
						      fill="#E95B5B"></path>
						<path id="Fill-16"
						      d="M11.9999814,18.2507264 C8.66285501,18.2507264 5.94793306,15.505768 5.94793306,12.13214 C5.94793306,8.75832424 8.66285501,6.01336578 11.9999814,6.01336578 C15.3371078,6.01336578 18.0520298,8.75832424 18.0520298,12.13214 C18.0520298,12.6806058 17.6122693,13.1252011 17.0697679,13.1252011 C16.5272666,13.1252011 16.0875061,12.6806058 16.0875061,12.13214 C16.0875061,9.85337746 14.253963,7.99948804 11.9999814,7.99948804 C9.74599982,7.99948804 7.91245675,9.85337746 7.91245675,12.13214 C7.91245675,14.4107147 9.74599982,16.2646041 11.9999814,16.2646041 C12.5424828,16.2646041 12.9822433,16.7091995 12.9822433,17.2576653 C12.9822433,17.806131 12.5424828,18.2507264 11.9999814,18.2507264"
						      fill="#7C5AE5"></path>
						<path id="Fill-18"
						      d="M7.6750381,19.9794266 C7.49426625,19.9794266 7.31145073,19.929088 7.14777139,19.8235271 C5.11562081,18.513032 3.70976203,16.4810791 3.18936947,14.1018271 C2.66897692,11.7227629 3.09610383,9.28096327 4.39216183,7.22647062 C5.68840562,5.17197798 7.69826162,3.75085059 10.0516399,3.22454885 C12.4046465,2.69824711 14.820078,3.13025782 16.8522286,4.4407529 C18.8843792,5.75106015 20.2900522,7.78301311 20.8106305,10.1622651 C21.3310231,12.5415171 20.9038962,14.9833167 19.6078382,17.0376216 C19.315965,17.5000608 18.7089952,17.6360503 18.251399,17.3409682 C17.7939886,17.0458861 17.6596638,16.4320553 17.9513512,15.969616 C18.9653828,14.3625361 19.2996157,12.4522975 18.8923681,10.5910827 C18.4853063,8.72986788 17.3856263,7.14025631 15.7958373,6.11526396 C14.2062341,5.08989594 12.3169546,4.7523641 10.4757942,5.16390125 C8.63481959,5.57543841 7.06249463,6.68720857 6.0486488,8.29447622 C3.95537393,11.6121306 4.92240116,16.0329149 8.2041627,18.1490161 C8.66138729,18.4440982 8.79571211,19.057929 8.50402474,19.5203683 C8.31675031,19.8173287 7.99923839,19.9794266 7.6750381,19.9794266"
						      fill="#552A94"></path>
						<path id="Fill-20"
						      d="M14.3786454,24 C13.9279234,24 13.5217906,23.6844444 13.420536,23.2212537 C13.3033037,22.6857483 13.6375366,22.15569 14.1674043,22.0371688 C19.5695658,20.8290414 22.9923405,15.4024235 21.7973513,9.94086902 C20.6025478,4.47931455 15.2353145,1.01853314 9.83259567,2.2268483 C4.43043418,3.43516346 1.00765945,8.86159358 2.20246292,14.3233359 C2.31988102,14.8588413 1.98527659,15.3888997 1.45559463,15.507233 C0.925912673,15.6259421 0.401618567,15.2878467 0.284572045,14.7521535 C-1.14432447,8.22127858 2.94840227,1.73266562 9.40844136,0.287871561 C15.8677373,-1.15729816 22.2863457,2.98098873 23.715428,9.5118636 C25.1443245,16.0427385 21.0515977,22.5315393 14.5915586,23.9763333 C14.520216,23.9922989 14.4486876,24 14.3786454,24"
						      fill="#000000"></path>
					</g>
				</g>
			</g>
		</svg>
		<span>{{ caption }}</span>
		<svg class="chevron" height="5px" version="1.1" viewBox="0 0 10 5" width="10px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<title>253EE906-1F83-4946-BD6F-DFD7507D5715</title>
			<g id="R2---Desktop-wireframes" fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
				<g id="FlyerView_Metro_FRENCH" fill="#333333" fill-rule="nonzero" transform="translate(-1542, -166)">
					<polygon id="icon-arrowright-red-copy-7" points="1542 166 1547 171 1552 166"></polygon>
				</g>
			</g>
		</svg>
	</button>
</template>

<style lang="scss" scoped>
.chevron {
  transition: transform 100ms;
  transform: rotate(-90deg);
}

.open {
  font-weight: 600;
  background-color: #F5F5F5;

  .chevron {
	transform: rotate(0deg);
  }
}

span {
  margin-left: 0.5em;
  margin-right: 0.5em;
}
</style>
